module.exports = __webpack_public_path__ + "static/character--keoni-forward@3x.8ce74430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--keoni-forward@3x.png
// module id = 68
// module chunks = 168707334958949